"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCalendarDropdownText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledCalendarDropdownText = styled_components_1.default.div `
  border-right: 1px solid ${config_1.colors.grayText};
  margin-right: 10px;
  min-width: ${(props) => (props.width ? props.width : '0')};
  padding-right: 5px;
  width: auto;
`;
